import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconDragHandleVerticalStyle0 = cosmosIconCss;

const CosmosIconDragHandleVertical$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDragHandleVertical extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5b7cdb4d47492cd37c063a2bc82a00a7216cd989', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fdc3e0f73278e5521904a3b57937264fa23e7c15', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8040caeba67c53fbf2f0e236f76a385c84a43b47', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.173 6.667a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667ZM6.84 11a1.333 1.333 0 1 0 2.667 0 1.333 1.333 0 0 0-2.667 0Zm5.667 0a1.333 1.333 0 1 0 2.666 0 1.333 1.333 0 0 0-2.666 0Zm0-5.667a1.333 1.333 0 1 0 2.666 0 1.333 1.333 0 0 0-2.666 0ZM13.84 18a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667Zm-7-1.333a1.333 1.333 0 1 0 2.667 0 1.333 1.333 0 0 0-2.667 0Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconDragHandleVerticalStyle0; }
}, [1, "cosmos-icon-drag-handle-vertical", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-drag-handle-vertical"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-drag-handle-vertical":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDragHandleVertical$1);
            }
            break;
    } });
}

const CosmosIconDragHandleVertical = CosmosIconDragHandleVertical$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDragHandleVertical, defineCustomElement };
